import { render, staticRenderFns } from "./AmostrasCatalisadoresDisplay.vue?vue&type=template&id=7f187035&"
import script from "./AmostrasCatalisadoresDisplay.vue?vue&type=script&lang=ts&"
export * from "./AmostrasCatalisadoresDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCard,VSimpleTable})
